/**
 * Creates a string separated with dashes
 * @param {string} path - ['global', 'contact', 'name']
 * keywords: path to string
 */
const generateKeyFromPath = (path: Array<string>): string => path.join('-');

export default generateKeyFromPath;
